import React, { Component } from 'react';
import api, { API_ENDPOINTS, getOtpCooldown, getOtpErrorMessage, isOtpRequestEnded } from '../../api/Api';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import { Link } from 'react-router-dom';
import AccountMenu from './AccountMenu';
import './AccountTheme.css';

class Account extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userDetails:'',
            full_name:'',
            email_id:'',
            email_otp:'',
            email_request_id:'',
            emailBusy:false,
            mobile_number:'',
            mobile_otp:'',
            mobile_request_id:'',
            enable_email_otp_box:false,
            enable_otp_box:false,
            mobileBusy:false,
            mobileCooldown:0,
            reauthRequired:false,
            reauthRequestId:'',
            reauthOtp:'',
            mobileDestination:'',
            editName:false,
            editEmail:false,
            editMobile:false,
            serviceCheck:false,
        }
    }

    componentDidMount() {
        this.emailUnmounted = false;
        this.preloadProfile();
    }

    componentDidUpdate(previousProps) {
        if (this.props.location?.state?.profileSetupSaved && previousProps.location?.key !== this.props.location?.key) {
            this.preloadProfile();
        }
    }

    componentWillUnmount() {
        this.emailUnmounted = true;
        clearInterval(this.mobileTimer);
    }

    startMobileCooldown(seconds) {
        clearInterval(this.mobileTimer);
        this.setState({mobileCooldown:seconds});
        if (!seconds) return;
        this.mobileTimer = setInterval(() => {
            this.setState(({mobileCooldown}) => {
                if (mobileCooldown <= 1) clearInterval(this.mobileTimer);
                return {mobileCooldown:Math.max(0, mobileCooldown - 1)};
            });
        }, 1000);
    }

    resetMobileFlow() {
        clearInterval(this.mobileTimer);
        this.setState({enable_otp_box:false, mobile_request_id:'', mobile_otp:'',
            reauthRequired:false, reauthRequestId:'', reauthOtp:'', mobileCooldown:0, mobileDestination:''});
    }

    handleMobileError(error, reauth = false) {
        if (error.response?.status === 403 && error.response?.data?.code === 'REAUTHENTICATION_REQUIRED') {
            this.resetMobileFlow();
            this.setState({reauthRequired:true});
            NotificationManager.error('Please verify your current mobile number again. Obtain a new OTP to continue.');
            return;
        }
        if (isOtpRequestEnded(error)) {
            this.startMobileCooldown(0);
            this.setState(reauth ? {reauthRequestId:'', reauthOtp:''}
                : {mobile_request_id:'', mobile_otp:'', enable_otp_box:false});
        }
        if (error.response?.status === 429) this.startMobileCooldown(getOtpCooldown(error.response));
        NotificationManager.error(getOtpErrorMessage(error));
    }

    async requestMobileCode(reauth = false, resend = false) {
        const endpoint = reauth
            ? (resend ? API_ENDPOINTS.customer.resendReauthentication : API_ENDPOINTS.customer.requestReauthentication)
            : (resend ? API_ENDPOINTS.customer.resendMobileChange : API_ENDPOINTS.customer.requestMobileChange);
        const payload = resend ? {request_id:reauth ? this.state.reauthRequestId : this.state.mobile_request_id}
            : reauth ? {} : {mobile:this.state.mobile_number};
        const response = await api.post(endpoint, payload);
        const data = response.data.data || response.data;
        if (!data.request_id) throw new Error('Missing OTP request');
        this.setState(reauth
            ? {reauthRequired:true, reauthRequestId:data.request_id, reauthOtp:'', mobileDestination:data.destination || this.state.userDetails.mobile_number}
            : {reauthRequired:false, reauthRequestId:'', reauthOtp:'', enable_otp_box:true,
                mobile_request_id:data.request_id, mobile_otp:'', mobileDestination:data.destination || this.state.mobile_number});
        this.startMobileCooldown(getOtpCooldown(response));
        NotificationManager.success(response.data.message || (reauth ? 'OTP sent to your current mobile number' : 'OTP sent to your new mobile number'));
    }

    getProfileFromResponse(responseData) {
        const data = responseData && responseData.data ? responseData.data : responseData;

        if (!data) {
            return null;
        }

        return data.customer || data.profile || data.user || data;
    }

    normalizeProfile(profile) {
        const firstName = profile.first_name || profile.firstName || '';
        const lastName = profile.last_name || profile.lastName || '';
        const fullName = profile.full_name || profile.fullName || profile.name || profile.username || [firstName, lastName].filter(Boolean).join(' ');
        const email = profile.email || profile.email_id || profile.emailAddress || '';
        const mobile = profile.mobile || profile.mobile_number || profile.phone || profile.phone_number || '';

        return {
            ...profile,
            first_name: firstName,
            last_name: lastName,
            username: fullName,
            email_id: email,
            mobile_number: mobile,
        };
    }

    async preloadProfile() {
        try {
          const response = await api.get(API_ENDPOINTS.customer.profile);
           let resVal=response.data;
            const profile = this.getProfileFromResponse(resVal);
            if(profile){
                const normalizedProfile = this.normalizeProfile(profile);
                this.setState({
                    userDetails:normalizedProfile,
                    full_name:normalizedProfile.username,
                    email_id:normalizedProfile.email_id,
                    mobile_number:normalizedProfile.mobile_number,
                    serviceCheck:true,
                });
            }else{
                NotificationManager.error(resVal.message || 'Unable to load profile');
                this.setState({serviceCheck:true});
            }
        } catch (error) {
          console.error(error);
          this.setState({serviceCheck:true});
        }
    }


    

    async submitName(){

        const { full_name}  = this.state ;

        if(full_name.length < 3) {
            NotificationManager.error('Please enter the valid name');
        }else{

            try {
                const [first_name, ...lastNameParts] = full_name.trim().split(' ');
                const response = await api.put(API_ENDPOINTS.customer.profile, {
                    first_name,
                    last_name: lastNameParts.join(' '),
                });
                let resVal=response.data;
                if(response.status === 200){
                    this.setState({editName:false});
                    NotificationManager.success(resVal.message || 'Profile updated');
                    this.preloadProfile();
                }else{
                    NotificationManager.error(resVal.message || 'Unable to update profile');
                }
            } catch (error) {
                console.error(error);
            }

        }
    }


    async getEmailOTP(){
        if (this.state.emailBusy) return;
        const {email_id} = this.state;
        const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        if (!emailPattern.test(email_id)) {
            NotificationManager.error('Please enter the valid email id');
            return;
        }
        this.setState({emailBusy:true});
        try {
            const response = await api.post(API_ENDPOINTS.customer.requestEmailVerification, {email:email_id});
            if (this.emailUnmounted) return;
            const result = response.data;
            const requestId = result.request_id || result.data?.request_id;
            if (response.status === 200 && requestId) {
                this.setState({enable_email_otp_box:true, email_request_id:requestId, email_otp:''});
                NotificationManager.success(result.message || 'Email OTP sent successfully');
            } else {
                NotificationManager.error(result.message || 'Unable to send email OTP');
            }
        } catch (error) {
            if (this.emailUnmounted) return;
            const result = error.response?.data;
            if (result?.code === 'EMAIL_OTP_DELIVERY_DELAYED' && result.data?.request_id) {
                // Retain the challenge so a late provider/fallback delivery can be verified.
                this.setState({enable_email_otp_box:true, email_request_id:result.data.request_id, email_otp:''});
            }
            NotificationManager.error(result?.message || 'Unable to send email OTP. Please try again.');
        } finally {
            if (!this.emailUnmounted) this.setState({emailBusy:false});
        }
    }

    async submitEmail(){

        const { email_otp, email_request_id }  = this.state ;

        if(!email_request_id) {
            NotificationManager.error('Please obtain the email OTP first');
        }else if(!/^\d{6}$/.test(email_otp)) {
            NotificationManager.error('Please enter the valid email OTP');
        }else{

            try {
                const response = await api.post(API_ENDPOINTS.customer.verifyEmail, {
                    request_id: email_request_id,
                    otp: email_otp,
                });
                let resVal=response.data;
                if(response.status === 200){
                    this.setState({editEmail:false, enable_email_otp_box:false, email_otp:'', email_request_id:''});
                    NotificationManager.success(resVal.message || 'Email verified');
                    this.preloadProfile();
                }else{
                    NotificationManager.error(resVal.message || 'Unable to verify email');
                }
            } catch (error) {
                console.error(error);
            }

        }
    }
    

    async getOTP(){
        if (this.state.mobileBusy || this.state.mobileCooldown > 0 || this.state.enable_otp_box) return;
        const { mobile_number, userDetails }  = this.state ;

        if(mobile_number===userDetails.mobile_number){
            NotificationManager.error('Please try different number');
        }else if(/^\d{10}$/.test(mobile_number)){
           
            try {
                this.setState({mobileBusy:true});
                await this.requestMobileCode(this.state.reauthRequired);
            } catch (error) {
                if (error.response?.status === 403 && error.response?.data?.code === 'REAUTHENTICATION_REQUIRED') {
                    this.setState({reauthRequired:true, enable_otp_box:false, mobile_request_id:''});
                    try {
                        await this.requestMobileCode(true);
                    } catch (reauthError) {
                        this.handleMobileError(reauthError, true);
                    }
                } else this.handleMobileError(error, this.state.reauthRequired);
            } finally {
                this.setState({mobileBusy:false});
            }

        }else{
            NotificationManager.error('Invalid mobile number');
        }
    }


    async resendOTP(){
        const {mobileBusy, mobileCooldown, reauthRequired, reauthRequestId, mobile_request_id} = this.state;
        if (mobileBusy || mobileCooldown > 0 || !(reauthRequired ? reauthRequestId : mobile_request_id)) return;
        this.setState({mobileBusy:true});
        try {
            await this.requestMobileCode(reauthRequired, true);
        } catch (error) {
            this.handleMobileError(error, reauthRequired);
        } finally {
            this.setState({mobileBusy:false});
        }
    }

    async submitReauthentication() {
        const {mobileBusy, reauthRequestId, reauthOtp} = this.state;
        if (mobileBusy || !reauthRequestId || !/^\d{6}$/.test(reauthOtp)) return;
        this.setState({mobileBusy:true});
        try {
            await api.post(API_ENDPOINTS.customer.verifyReauthentication, {request_id:reauthRequestId, otp:reauthOtp});
        } catch (error) {
            this.handleMobileError(error, true);
            this.setState({mobileBusy:false});
            return;
        }
        this.setState({reauthRequired:false, reauthRequestId:'', reauthOtp:''});
        this.startMobileCooldown(0);
        NotificationManager.success('Current mobile number verified. Sending OTP to your new number.');
        try {
            await this.requestMobileCode();
        } catch (error) {
            this.handleMobileError(error);
        } finally {
            this.setState({mobileBusy:false});
        }
    }


    async submitMobile(){
            if (this.state.mobileBusy || !this.state.mobile_request_id || this.state.reauthRequired) return;

            const { mobile_number, mobile_otp, userDetails }  = this.state ;
    
            if(mobile_number===userDetails.mobile_number){
                NotificationManager.error('Please try different number');
            }else if(mobile_number.length!==10){
                NotificationManager.error('Invalid mobile number');
            }else if(!/^\d{6}$/.test(mobile_otp)){
                NotificationManager.error('Please enter the valid mobile OTP');
            }else{
    
                try {
                    this.setState({mobileBusy:true});
                    const response = await api.post(API_ENDPOINTS.customer.verifyMobileChange, {
                        request_id: this.state.mobile_request_id,
                        otp: mobile_otp,
                    });
                    let resVal=response.data;
                    if(response.status === 200){
                        this.resetMobileFlow();
                        this.setState({editMobile:false});
                        NotificationManager.success(resVal.message || 'Mobile number updated');
                        this.preloadProfile();
                    }else{
                        NotificationManager.error(resVal.message || 'Unable to update mobile number');
                    }
                } catch (error) {
                    this.handleMobileError(error);
                } finally {
                    this.setState({mobileBusy:false});
                }
            }
    }


    loadNameComponent(){
        const { editName, userDetails, full_name }  = this.state ;
        if(editName===true){
            return(
                <div className="form-row">
                    <div className="ps-form__group col-md-6">
                        <label className="ps-form__label" htmlFor="account-name">Full name</label>
                        <input id="account-name" type="text" autoComplete="name" className="form-control ps-form__input" name="full_name" onChange={(event)=>this.setState({'full_name':event.target.value})} value={full_name}/>
                        
                        <br/>

                        <button type="button" className="nw-account__button" onClick={()=>this.submitName()}>Save changes</button>
                        <button type="button" className="nw-account__button nw-account__button--secondary" onClick={()=>this.setState({editName:false, full_name:userDetails.username || ''})}>Cancel</button>
                    </div>
                </div>
            )
        }else{
            return(
            <div className="form-row">
                <div className="ps-form__group col-md-6">
                <label className="ps-form__label" htmlFor="account-name">Full name <button type="button" className="nw-account__edit" onClick={()=>this.setState({editName:true})}>Edit<span className="sr-only"> full name</span></button></label>
                <input id="account-name" type="text" className="form-control ps-form__input nw-account__value" value={userDetails.username || '-'} disabled/>
                </div>
            </div>
            )
        }
    }



    loadEmailComponent(){
        const { editEmail, userDetails, email_id, email_otp, enable_email_otp_box }  = this.state ;
        if(editEmail===true){
            return(
                <>
                <div className="form-row">
                    <div className="ps-form__group col-md-6">
                        <label className="ps-form__label" htmlFor="account-email">Email address</label>
                        <div className="mobileNumberBox">
                            <input id="account-email" disabled={this.state.emailBusy} type="email" autoComplete="email" className="form-control ps-form__input mobileNumberBoxLeft" name="email_id" onChange={(event)=>this.setState({'email_id':event.target.value})} value={email_id}/>
                            <input className="btn mobileNumberBoxRight" name="email_otp_button" value={this.state.emailBusy ? 'Sending…' : 'Obtain OTP'} disabled={this.state.emailBusy} type="button" onClick={()=>this.getEmailOTP()}/>
                        </div>
                    </div>
                </div>

                {(enable_email_otp_box===true)?
                <div className="form-row">
                    <div className="ps-form__group col-md-6">
                        <label className="ps-form__label" htmlFor="account-email-otp">Email OTP *</label>
                        <input id="account-email-otp" className="form-control ps-form__input" inputMode="numeric" autoComplete="one-time-code" name="email_otp" maxLength='6' type="text" value={email_otp} onChange={(event)=>this.setState({email_otp:event.target.value})}/>
                    </div>
                </div>
                : null }

                <div className="form-row">
                    <div className="ps-form__group col-md-6">
                        <br/>

                        <button type="button" className="nw-account__button" onClick={()=>this.submitEmail()}>Verify email</button>
                        <button type="button" className="nw-account__button nw-account__button--secondary" disabled={this.state.emailBusy} onClick={()=>this.setState({editEmail:false, enable_email_otp_box:false, email_otp:'', email_request_id:'', email_id:userDetails.email_id || ''})}>Cancel</button>
                    </div>
                </div>
                </>
            )
        }else{
            return(
            <div className="form-row">
                <div className="ps-form__group col-md-6">
                <label className="ps-form__label" htmlFor="account-email">Email address <button type="button" className="nw-account__edit" onClick={()=>this.setState({editEmail:true})}>Edit<span className="sr-only"> email address</span></button></label>
                <input id="account-email" type="text" className="form-control ps-form__input nw-account__value" value={userDetails.email_id || 'Not added yet'} disabled/>
                </div>
            </div>
            )
        }
    }


    
    loadMobileComponent(){
        const { enable_otp_box, editMobile, userDetails, mobile_number, mobile_otp }  = this.state ;
        const {mobileBusy, mobileCooldown, reauthRequired, reauthRequestId, reauthOtp, mobileDestination} = this.state;
        if(editMobile===true){
            return(
                <>
                <div className="form-row">
                <div className="ps-form__group col-md-6">
                    <label className="ps-form__label">Mobile Number *</label>
                    <div className="mobileNumberBox">
                        <input className="form-control ps-form__input mobileNumberBoxLeft" aria-label="New mobile number" disabled={mobileBusy || enable_otp_box || reauthRequired} maxLength='10' type="text" value={mobile_number} onChange={(event)=>this.setState({mobile_number:event.target.value.replace(/\D/g, '').slice(0, 10)})}/>
                        <input className="btn mobileNumberBoxRight" name="mobile_otp_button" disabled={mobileBusy || mobileCooldown > 0 || enable_otp_box || Boolean(reauthRequestId)} value={mobileBusy ? 'Please wait...' : mobileCooldown > 0 ? `Obtain OTP (${mobileCooldown}s)` : 'Obtain OTP'} type="button" onClick={()=>this.getOTP()}/>
                    </div>
                </div>
                </div>

                {reauthRequired && <div className="form-row">
                    <div className="ps-form__group col-md-6">
                        <p>Verify your current mobile number {mobileDestination || userDetails.mobile_number} before changing to {mobile_number}.</p>
                        {reauthRequestId && <>
                            <label className="ps-form__label" htmlFor="reauth-otp">Current mobile OTP *</label>
                            <input id="reauth-otp" className="form-control ps-form__input" inputMode="numeric" autoComplete="one-time-code" maxLength={6} value={reauthOtp} disabled={mobileBusy} onChange={(event)=>this.setState({reauthOtp:event.target.value.replace(/\D/g, '').slice(0, 6)})}/>
                            <button type="button" className="btn" disabled={mobileBusy || mobileCooldown > 0} onClick={()=>this.resendOTP()}>{mobileCooldown > 0 ? `Resend current number OTP (${mobileCooldown}s)` : 'Resend current number OTP'}</button>
                            <button type="button" className="ps-btn ps-btn--sm ps-btn--warning byosButton" disabled={mobileBusy || !/^\d{6}$/.test(reauthOtp)} onClick={()=>this.submitReauthentication()}>{mobileBusy ? 'Please wait...' : 'Verify current number'}</button>
                        </>}
                    </div>
                </div>}

                {(enable_otp_box===true)?
                <div className="form-row">
                    <div className="ps-form__group col-md-6">
                    <label className="ps-form__label">New mobile OTP * ({mobileDestination || mobile_number})</label>
                    <div className="mobileNumberBox">
                        <input className="form-control ps-form__input mobileNumberBoxLeft" aria-label="New mobile OTP" name="mobile_otp" inputMode="numeric" autoComplete="one-time-code" disabled={mobileBusy} maxLength='6' type="text" value={mobile_otp} onChange={(event)=>this.setState({mobile_otp:event.target.value.replace(/\D/g, '').slice(0, 6)})}/>
                        <button type="button" className="btn mobileNumberBoxRight" name="mobile_otp_resend_button" disabled={mobileBusy || mobileCooldown > 0} onClick={()=>this.resendOTP()}>{mobileCooldown > 0 ? `Resend OTP (${mobileCooldown}s)` : 'Resend OTP'}</button>
                    </div>
                </div>
                </div>
                : null }

                <div className="form-row">
                    <div className="ps-form__group col-md-6">
                        <br/>
                        <button type="button" className="ps-btn ps-btn--sm ps-btn--warning byosButton" disabled={mobileBusy || reauthRequired || !enable_otp_box || !/^\d{6}$/.test(mobile_otp)} onClick={()=>this.submitMobile()}>{mobileBusy ? 'Please wait...' : 'Save'}</button>
                        <button type="button" className="ps-btn ps-btn--sm ps-btn--primary byosButton" disabled={mobileBusy} onClick={()=>{this.resetMobileFlow(); this.setState({editMobile:false, mobile_number:userDetails.mobile_number});}}>Cancel</button>
                    </div>
                </div>
            </>
            )
        }else{
            return(
            <div className="form-row">
                <div className="ps-form__group col-md-6">
                <label className="ps-form__label" htmlFor="account-mobile">Mobile number <button type="button" className="nw-account__edit" onClick={()=>this.setState({editMobile:true})}>Edit<span className="sr-only"> mobile number</span></button></label>
                <input id="account-mobile" type="text" className="form-control ps-form__input nw-account__value" value={userDetails.mobile_number || '-'} disabled/>
                </div>
            </div>
            )
        }
    }


    render() {
        const { userDetails, serviceCheck }  = this.state ;
        const profileName = userDetails && userDetails.username ? userDetails.username : localStorage.getItem('natureway_username');

        return (
            <div className="ps-account-page ps-account-page--profile nw-account">
                <div className="ps-categogy ps-categogy--separate ps-account-shell">
                    <div className="container whiteContainer ps-account-shell__container">
                        <div className="ps-account-shell__layout">
                            <AccountMenu {...this.props} profileName={profileName}/>

                            <main className="ps-account-shell__content">
                                <div className="ps-account-shell__topbar">
                                    <nav aria-label="Breadcrumb"><ul className="ps-breadcrumb ps-account-shell__breadcrumb">
                                        <li className="ps-breadcrumb__item"><Link to="/">Home</Link></li>
                                        <li className="ps-breadcrumb__item active" aria-current="page">Profile information</li>
                                    </ul></nav>
                                </div>

                                <section className="ps-account-shell__hero">
                                    <div className="ps-account-shell__heroCopy">
                                        <h1>My <span>account</span></h1>
                                        <p>{profileName ? `Welcome back, ${profileName}.` : 'Manage your account details.'}</p>
                                    </div>
                                </section>

                                <section className="ps-account-shell__panel">
                                    {this.props.location?.state?.profileSetupSaved && <p role="status">Your profile details have been saved.</p>}
                                    <div className="accountBox ps-form--review ps-account-shell__card">
                                        <div className="ps-account-shell__cardHeader">
                                            <span className="ps-account-shell__panelLabel">Personal details</span>
                                            <h2>Profile information</h2>
                                            <p>Keep your contact details up to date for a smooth shopping experience.</p>
                                        </div>

                                        {!serviceCheck ? <div className="nw-account__loading" role="status" aria-label="Loading profile" aria-busy="true"><span/><span/><span/></div> : <>
                                        <div className="ps-account-dashboard__fieldGroup">
                                            {this.loadNameComponent()}
                                        </div>

                                        <div className="ps-account-dashboard__fieldGroup">
                                            {this.loadEmailComponent()}
                                        </div>

                                        <div className="ps-account-dashboard__fieldGroup">
                                            {this.loadMobileComponent()}
                                        </div>
                                        <p className="nw-account__security-note">For your security, changes to your email or mobile number require OTP verification.</p>
                                        </>}
                                    </div>
                                </section>
                            </main>
                        </div>
                    </div>
                </div>
                <NotificationContainer/>
            </div>
        );
    }
}

export default Account;
